export const casinoTabs = {
  roulettetab: {
    AutoRoulette: {
      href: "/casino/ezugi/AutoRoulette",
      code: "5001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/AutoRoulette.jpg", alt: "" },
    },
    CasinoMarinaRoulette: {
      href: "/casino/ezg-casino-marina-roulette-1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/ezugi/CasinoMarinaRoulette.jpg",
        alt: "",
      },
    },
    CasinoMarinaRoulette2: {
      href: "/casino/ezg-casino-marina-roulette-2",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/ezugi/CasinoMarinaRoulette2.jpg",
        alt: "",
      },
    },
    DiamondRoulette: {
      href: "/casino/ezugi/DiamondRoulette",
      code: "221003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/DiamondRoulette.jpg", alt: "" },
    },
    // FiestaRoulette: {
    //   href: "/casino/ezugi/FiestaRoulette",
    //   code: "431001",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/roulette/ezugi/FiestaRoulette.jpg", alt: "" },
    // },
    ItalianRoulette: {
      href: "/casino/ezugi/ItalianRoulette",
      code: "1000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/ItalianRoulette.jpg", alt: "" },
    },
    NamasteRoulette: {
      href: "/casino/ezugi/NamasteRoulette",
      code: "221005",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/NamasteRoulette.jpg", alt: "" },
    },
    // OracleCasinoRoulette: {
    //   href: "/casino/ezg-oracle-blaze-roulette",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: {
    //     src: "./images/roulette/ezugi/OracleCasinoRoulette.jpg",
    //     alt: "",
    //   },
    // },
    OracleRoulette2: {
      href: "/casino/ezugi/OracleRoulette2",
      code: "611001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/OracleRoulette2.jpg", alt: "" },
    },
    OracleRoulette360: {
      href: "/casino/ezg-oracle-360-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/ezugi/OracleRoulette360.jpg",
        alt: "",
      },
    },
    PrestigeAutoRoulette: {
      href: "/casino/ezugi/PrestigeAutoRoulette",
      code: "221004",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/ezugi/PrestigeAutoRoulette.jpg",
        alt: "",
      },
    },
    RuletadelSol: {
      href: "/casino/ezg-ruleta-del-sol",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/ezugi/RuletadelSol.jpg",
        alt: "",
      },
    },
    RussianRoulette: {
      href: "/casino/ezugi/RussianRoulette",
      code: "601000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/RussianRoulette.jpg", alt: "" },
    },
    SpanishRoulette: {
      href: "/casino/ezugi/SpanishRoulette",
      code: "411000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/SpanishRoulette.jpg", alt: "" },
    },
    SpeedAutoRoulette: {
      href: "/casino/ezugi/SpeedAutoRoulette",
      code: "221002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/SpeedAutoRoulette.jpg", alt: "" },
    },
    SpeedRoulette: {
      href: "/casino/ezugi/SpeedRoulette",
      code: "221000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/SpeedRoulette.jpg", alt: "" },
    },
    TurkishRoulette: {
      href: "/casino/ezg-turkish-roulette",
      code: "5501000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/ezugi/TurkishRoulette.jpg", alt: "" },
    },
    AmericanRoulette: {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/AmericanRoulette.jpg",
        alt: "",
      },
    },
    AmericanRoulette: {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/AmericanRoulette.jpg",
        alt: "",
      },
    },
    DoubleBallRoulette: {
      href: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/DoubleBallRoulette.jpg",
        alt: "",
      },
    },
    DragonaraRoulette: {
      href: "/casino/ezgevo-dragonara-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/DragonaraRoulette.jpg",
        alt: "",
      },
    },
    FirstPersonAmericanRoulette: {
      href: "/casino/ezgevo-first-person-american-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/FirstPersonAmericanRoulette.jpg",
        alt: "",
      },
    },
    FirstPersonLightningRoulette: {
      href: "/casino/ezgevo-first-person-lightning-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/FirstPersonLightningRoulette.jpg",
        alt: "",
      },
    },
    FirstPersonRoulette: {
      href: "/casino/ezgevo-first-person-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/FirstPersonRoulette.jpg",
        alt: "",
      },
    },
    footballstudioroulette: {
      href: "/casino/ezgevo-football-studio-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/footballstudioroulette.jpg",
        alt: "",
      },
    },
    ImmersiveRoulette: {
      href: "/casino/ezgevo-immersive-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/ImmersiveRoulette.jpg",
        alt: "",
      },
    },
    InstantRoulette: {
      href: "/casino/ezgevo-instant-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/InstantRoulette.jpg",
        alt: "",
      },
    },
    LightningRoulette: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/LightningRoulette.jpg",
        alt: "",
      },
    },
    Roulette: {
      href: "/casino/ezgevo-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/Roulette.jpg",
        alt: "",
      },
    },
    SalonPrivatRoulette: {
      href: "/casino/ezgevo-salon-prive-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/SalonPrivatRoulette.jpg",
        alt: "",
      },
    },
    SpeedAutoRoulette: {
      href: "/casino/ezgevo-speed-auto-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/SpeedAutoRoulette.jpg",
        alt: "",
      },
    },
    SpeedRoulette: {
      href: "/casino/ezgevo-speed-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/SpeedRoulette.jpg",
        alt: "",
      },
    },
    TurkishLightningRoulette: {
      href: "/casino/ezgevo-turkish-lightning-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/TurkishLightningRoulette.jpg",
        alt: "",
      },
    },
    VIPRoulette: {
      href: "/casino/ezgevo-vip-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/VIPRoulette.jpg",
        alt: "",
      },
    },
    XXXtremeLightningRoulette: {
      href: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/roulette/evolution/XXXtremeLightningRoulette.jpg",
        alt: "",
      },
    },
  },

  baccarattab: {
    Baccarat: {
      href: "/casino/ezg-baccarat",
      code: "106",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/Baccarat.jpg", alt: "" },
    },
    CasinoMarinaBaccarat1: {
      href: "/casino/ezg-casino-marina-baccarat-1",
      code: "130",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.jpg",
        alt: "",
      },
    },
    CasinoMarinaBaccarat2: {
      href: "/casino/ezg-casino-marina-baccarat-2",
      code: "32101",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.jpg",
        alt: "",
      },
    },
    CasinoMarinaBaccarat3: {
      href: "/casino/ezg-casino-marina-baccarat-3",
      code: "32103",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.jpg",
        alt: "",
      },
    },
    CasinoMarinaBaccarat4: {
      href: "/casino/ezg-casino-marina-baccarat-4",
      code: "32104",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.jpg",
        alt: "",
      },
    },
    CricketWar: {
      href: "/casino/ezg-cricket-war",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/CricketWar.jpg", alt: "" },
    },
    DragonTiger: {
      href: "/casino/ezg-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/DragonTiger.jpg", alt: "" },
    },
    // FiestaBaccarat: {
    //   href: "/casino/ezg-fiesta-baccarat",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/baccarat/ezugi/FiestaBaccarat.jpg", alt: "" },
    // },
    FortuneBaccarat: {
      href: "/casino/ezg-fortune-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/FortuneBaccarat.jpg", alt: "" },
    },
    KnockoutBaccarat: {
      href: "/casino/ezg-knockout-baccarat",
      code: "120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/KnockoutBaccarat.jpg", alt: "" },
    },
    NoCommissionBaccarat: {
      href: "/casino/ezg-no-commission-baccarat",
      code: "170",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/NoCommissionBaccarat.jpg",
        alt: "",
      },
    },
    // SpeedCricketBaccarat: {
    //   href: "/casino/ezg-speed-cricket-baccarat",
    //   code: "101",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: {
    //     src: "./images/baccarat/ezugi/SpeedCricketBaccarat.jpg",
    //     alt: "",
    //   },
    // },
    SpeedFortuneBaccarat: {
      href: "/casino/ezg-speed-fortune-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/ezugi/SpeedFortuneBaccarat.jpg",
        alt: "",
      },
    },
    Super6Baccarat: {
      href: "/casino/ezg-super-6-baccarat",
      code: "32100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/Super6Baccarat.jpg", alt: "" },
    },
    VIPFortuneBaccarat: {
      href: "/casino/ezg-vip-fortune-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/ezugi/VIPFortuneBaccarat.jpg", alt: "" },
    },
    // VIPNoCommissionSpeedCricketBaccarat: {
    //   href: "/casino/ezg-vip-no-commission-speed-cricket-baccarat",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: {
    //     src: "./images/baccarat/ezugi/VIPNoCommissionSpeedCricketBaccarat.jpg",
    //     alt: "",
    //   },
    // },
    BaccaratA: {
      href: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/BaccaratA.jpg",
        alt: "",
      },
    },
    BaccaratB: {
      href: "/casino/ezgevo-baccarat-b",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/BaccaratB.jpg",
        alt: "",
      },
    },
    BaccaratC: {
      href: "/casino/ezgevo-baccarat-c",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/BaccaratC.jpg",
        alt: "",
      },
    },
    BaccaratControlSqueeze: {
      href: "/casino/ezgevo-baccarat-control-squeeze",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/BaccaratControlSqueeze.jpg",
        alt: "",
      },
    },
    BaccaratSqueeze: {
      href: "/casino/ezgevo-baccarat-squeeze",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/BaccaratSqueeze.jpg",
        alt: "",
      },
    },
    FirstPersonBaccarat: {
      href: "/casino/ezgevo-first-person-baccarat",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/FirstPersonBaccarat.jpg",
        alt: "",
      },
    },
    FirstPersonGoldenWealthBaccarat: {
      href: "/casino/ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.jpg",
        alt: "",
      },
    },
    FirstPersonLightningBaccarat: {
      href: "/casino/ezgevo-first-person-lightning-baccarat",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/FirstPersonLightningBaccarat.jpg",
        alt: "",
      },
    },
    GoldenWealthBaccarat: {
      href: "/casino/ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/GoldenWealthBaccarat.jpg",
        alt: "",
      },
    },
    LightningBaccarat: {
      href: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/LightningBaccarat.jpg",
        alt: "",
      },
    },
    NoCommissionBaccarat: {
      href: "/casino/ezgevo-no-commission-baccarat-evo",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/NoCommissionBaccarat.jpg",
        alt: "",
      },
    },
    NoCommissionSpeedBaccaratA: {
      href: "/casino/ezgevo-no-commission-speed-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/NoCommSpeedBaccaratA.jpg",
        alt: "",
      },
    },
    NoCommissionSpeedBaccaratB: {
      href: "/casino/ezgevo-no-commission-speed-baccarat-b",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/NoCommSpeedBaccaratB.jpg",
        alt: "",
      },
    },
    NoCommissionSpeedBaccaratC: {
      href: "/casino/ezgevo-no-commission-speed-baccarat-c",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/NoCommSpeedBaccaratC.jpg",
        alt: "",
      },
    },
    SalonPrivatBaccaratA: {
      href: "/casino/ezgevo-salon-priv-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SalonPrivateBaccaratA.jpg",
        alt: "",
      },
    },
    SalonPrivatBaccaratB: {
      href: "/casino/ezgevo-salon-priv-baccarat-b",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SalonPrivatBaccaratB.jpg",
        alt: "",
      },
    },
    SalonPrivatBaccaratC: {
      href: "/casino/ezgevo-salon-priv-baccarat-c",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SalonPrivatBaccaratC.jpg",
        alt: "",
      },
    },
    SalonPrivatBaccaratD: {
      href: "/casino/ezgevo-salon-priv-baccarat-d",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SalonPrivatBaccaratD.jpg",
        alt: "",
      },
    },
    SalonPrivatBaccaratE: {
      href: "/casino/ezgevo-salon-priv-baccarat-e",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SalonPrivatBaccaratE.jpg",
        alt: "",
      },
    },
    SpeedBaccaratA: {
      href: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratA.jpg",
        alt: "",
      },
    },
    SpeedBaccaratB: {
      href: "/casino/ezgevo-speed-baccarat-b",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratB.jpg",
        alt: "",
      },
    },
    SpeedBaccaratC: {
      href: "/casino/ezgevo-speed-baccarat-c",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratC.jpg",
        alt: "",
      },
    },
    SpeedBaccaratD: {
      href: "/casino/ezgevo-speed-baccarat-d",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratD.jpg",
        alt: "",
      },
    },
    SpeedBaccaratE: {
      href: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratE.jpg",
        alt: "",
      },
    },
    SpeedBaccaratF: {
      href: "/casino/ezgevo-speed-baccarat-f",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratF.jpg",
        alt: "",
      },
    },
    SpeedBaccaratG: {
      href: "/casino/ezgevo-speed-baccarat-g",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratG.jpg",
        alt: "",
      },
    },
    SpeedBaccaratH: {
      href: "/casino/ezgevo-speed-baccarat-h",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratH.jpg",
        alt: "",
      },
    },
    SpeedBaccaratI: {
      href: "/casino/ezgevo-speed-baccarat-i",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratI.jpg",
        alt: "",
      },
    },
    SpeedBaccaratJ: {
      href: "/casino/ezgevo-speed-baccarat-j",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratJ.jpg",
        alt: "",
      },
    },
    SpeedBaccaratK: {
      href: "/casino/ezgevo-speed-baccarat-k",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratK.jpg",
        alt: "",
      },
    },
    SpeedBaccaratL: {
      href: "/casino/ezgevo-speed-baccarat-l",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratL.jpg",
        alt: "",
      },
    },
    SpeedBaccaratM: {
      href: "/casino/ezgevo-speed-baccarat-m",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratM.jpg",
        alt: "",
      },
    },
    SpeedBaccaratN: {
      href: "/casino/ezgevo-speed-baccarat-n",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratN.jpg",
        alt: "",
      },
    },
    SpeedBaccaratO: {
      href: "/casino/ezgevo-speed-baccarat-o",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratO.jpg",
        alt: "",
      },
    },
    SpeedBaccaratP: {
      href: "/casino/ezgevo-speed-baccarat-p",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratP.jpg",
        alt: "",
      },
    },
    SpeedBaccaratQ: {
      href: "/casino/ezgevo-speed-baccarat-q",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratQ.jpg",
        alt: "",
      },
    },
    SpeedBaccaratR: {
      href: "/casino/ezgevo-speed-baccarat-r",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratR.jpg",
        alt: "",
      },
    },
    SpeedBaccaratS: {
      href: "/casino/ezgevo-speed-baccarat-s",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/baccarat/evolution/SpeedBaccaratS.jpg",
        alt: "",
      },
    },
  },

  AndarBahartab: {
    AndarBahar: {
      href: "/casino/ezg-andar-bahar",
      code: "228000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/ezugi/AndarBahar.jpg", alt: "" },
    },
    OTTAndarBahar: {
      href: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/ezugi/OTTAndarBahar.jpg", alt: "" },
    },
    UltimateAndarBahar: {
      href: "/casino/ezg-ultimate-andar-bahar",
      code: "228100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/andarbahar/ezugi/UltimateAndarBahar.jpg",
        alt: "",
      },
    },
  },

  pokertab: {
    BetonTeenPattiEzugi: {
      href: "/casino/ezg-bet-on-teen-patti",
      code: "1000352",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/ezugi/BetonTeenPatti.jpg", alt: "" },
    },
    CasinoHoldemEzugi: {
      href: "/casino/ezg-casino-holdem",
      code: "150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/ezugi/CasinoHoldem.jpg", alt: "" },
    },
    TeenPatti3CardEzugi: {
      href: "/casino/ezg-teen-patti-3-card",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/ezugi/TeenPatti3Card.jpg", alt: "" },
    },
    OneDayTeenPattiEzugi: {
      href: "/casino/ezg-one-day-teen-patti",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/ezugi/OneDayTeenPatti.jpg", alt: "" },
    },
    Hand2CasinoHoldemEvolution: {
      href: "/casino/ezgevo-2-hand-casino-holdem",
      code: "1000352",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/evolution/2HandCasinoHoldem.jpg", alt: "" },
    },
    CasinoHoldemEvolution: {
      href: "/casino/ezgevo-casino-holdem-evo",
      code: "150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/evolution/CasinoHoldem.jpg", alt: "" },
    },
    ThreeCardPokerEvolution: {
      href: "/casino/ezgevo-three-card-poker",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/evolution/ThreeCardPoker.jpg", alt: "" },
    },
    TexasHoldemBonusPokerEvolution: {
      href: "/casino/ezgevo-texas-holdem-bonus-poker",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/poker/evolution/TexasHoldemBonusPoker.jpg",
        alt: "",
      },
    },
    UltimateTexasHoldemEvolution: {
      href: "/casino/ezgevo-ultimate-texas-holdem",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/poker/evolution/UltimateTexasHoldem.jpg",
        alt: "",
      },
    },
    // SideBetCityEvolution: {
    //   href: "/casino/ezgevo-side-bet-city",
    //   code: "224100",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/poker/evolution/SideBetCity.jpg", alt: "" },
    // },
  },

  Blackjacktab: {
    // FiestaUnlimitedBlackjackEzugi: {
    //   href: "/casino/ezg-fiesta-unlimited-blackjack",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: {
    //     src: "./images/blackjack/ezugi/FiestaBlackjackUnlimited.jpg",
    //     alt: "",
    //   },
    // },
    TurkishUnlimitedBlackjackEzugi: {
      href: "/casino/ezg-turkish-unlimited-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/ezugi/UnlimitedTurkishBlackjack.jpg",
        alt: "",
      },
    },
    // TurkishBlackjackEzugi: {
    //   href: "/casino/ezg-turkish-blackjack",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/blackjack/ezugi/TurkishBlackjack.jpg", alt: "" },
    // },
    // TurkishBlackjack1Ezugi: {
    //   href: "/casino/ezg-turkish-blackjack-1",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/blackjack/ezugi/TurkishBlackjack1.jpg", alt: "" },
    // },
    // TurkishBlackjack2Ezugi: {
    //   href: "/casino/ezg-turkish-blackjack-2",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/blackjack/ezugi/TurkishBlackjack2.jpg", alt: "" },
    // },
    RumbaBlackjack1Ezugi: {
      href: "/casino/ezg-rumba-blackjack-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/RumbaBlackjack1.jpg", alt: "" },
    },
    RumbaBlackjack4Ezugi: {
      href: "/casino/ezg-rumba-blackjack-4",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/RumbaBlackjack4.jpg", alt: "" },
    },
    RussianBlackjack2Ezugi: {
      href: "/casino/ezg-russian-blackjack-2",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/RussianBlackjack2.jpg", alt: "" },
    },
    SpanishUnlimitedBlackjackEzugi: {
      href: "/casino/ezg-spanish-unlimited-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/ezugi/SpanishUnlimitedBlackjack.jpg",
        alt: "",
      },
    },
    VIPDiamondBlackjackEzugi: {
      href: "/casino/ezg-vip-diamond-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/ezugi/VIPDiamondBlackjack.jpg",
        alt: "",
      },
    },
    RussianBlackjack1Ezugi: {
      href: "/casino/ezg-russian-blackjack-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/RussianBlackjack1.jpg", alt: "" },
    },
    RussianBlackjack1Ezugi: {
      href: "/casino/ezg-russian-blackjack-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/RussianBlackjack1.jpg", alt: "" },
    },
    // ItalianBlackjackEzugi: {
    //   href: "/casino/ezg-italian-blackjack",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/blackjack/ezugi/ItalianBlackjack.jpg", alt: "" },
    // },
    Goldblackjack4Ezugi: {
      href: "/casino/ezg-gold-blackjack-4",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/goldblackjack4.jpg", alt: "" },
    },
    // Goldblackjack6Ezugi: {
    //   href: "/casino/ezg-gold-blackjack-6",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "",
    //   cover: { src: "./images/blackjack/ezugi/goldblackjack6.jpg", alt: "" },
    // },
    Goldblackjack5Ezugi: {
      href: "/casino/ezg-gold-blackjack-5",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/goldblackjack5.jpg", alt: "" },
    },
    SalonPriveBlackjack5Ezugi: {
      href: "/casino/ezg-salon-prive-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/ezugi/SalonPriveBlackjack.jpg",
        alt: "",
      },
    },
    goldBlackjack3Ezugi: {
      href: "/casino/ezg-gold-blackjack-3",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/ezugi/goldblackjack3.jpg", alt: "" },
    },
    InfiniteBlackjackEvolution: {
      href: "/casino/ezgevo-infinite-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/InfiniteBlackjack.jpg",
        alt: "",
      },
    },
    FreeBetBlackjackEvolution: {
      href: "/casino/ezgevo-free-bet-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/FreeBetBlackjack.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack1Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack1.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack2Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-2",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack2.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack3Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-3",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack4.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack4Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-4",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack4.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack5Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-5",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack5.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack6Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-6",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack6.jpg",
        alt: "",
      },
    },
    FreeBetBlackjack7Evolution: {
      href: "/casino/ezgevo-free-bet-blackjack-7",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/freebetblackjack7.jpg",
        alt: "",
      },
    },
    PowerBlackjackEvolution: {
      href: "/casino/ezgevo-power-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/PowerBlackjack.jpg",
        alt: "",
      },
    },
    LightningBlackjackEvolution: {
      href: "/casino/ezgevo-lightning-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/light.jpg", alt: "" },
    },
    CrapsEvolution: {
      href: "/casino/ezgevo-craps",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/PowerBlackjack.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack1Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack1.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack2Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-2",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack2.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack3Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-3",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack3.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack4Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-4",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack4.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack5Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-5",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack5.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack6Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-6",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack6.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack8Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-8",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack8.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack9Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-9",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack9.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack10Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-10",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack10.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack11Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-11",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack11.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack12Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-12",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack12.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack13Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-13",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack13.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack14Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-14",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack14.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack15Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-15",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack15.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack16Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-16",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack16.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack17Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-17",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack17.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack18Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-18",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack18.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack19Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-19",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack19.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack20Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-20",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack20.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack21Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-21",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack21.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack22Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-22",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack22.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack23Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-23",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack23.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack24Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-24",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack24.jpg",
        alt: "",
      },
    },
    ClassicSpeedBlackjack25Evolution: {
      href: "/casino/ezgevo-classic-speed-blackjack-25",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/ClassicSpeedBlackjack25.jpg",
        alt: "",
      },
    },
    BlackjackAEvolution: {
      href: "/casino/ezgevo-blackjack-a",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackA.jpg", alt: "" },
    },
    BlackjackBEvolution: {
      href: "/casino/ezgevo-blackjack-b",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackB.jpg", alt: "" },
    },
    BlackjackCEvolution: {
      href: "/casino/ezgevo-blackjack-c",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackC.jpg", alt: "" },
    },
    BlackjackPartyEvolution: {
      href: "/casino/ezgevo-blackjack-party",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackParty.jpg",
        alt: "",
      },
    },
    BlackjackSilverAEvolution: {
      href: "/casino/ezgevo-blackjack-silver-a",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverA.jpg",
        alt: "",
      },
    },
    BlackjackSilverBEvolution: {
      href: "/casino/ezgevo-blackjack-silver-b",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverB.jpg",
        alt: "",
      },
    },
    BlackjackSilverCEvolution: {
      href: "/casino/ezgevo-blackjack-silver-c",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverC.jpg",
        alt: "",
      },
    },
    BlackjackSilverDEvolution: {
      href: "/casino/ezgevo-blackjack-silver-d",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverD.jpg",
        alt: "",
      },
    },
    BlackjackSilverEEvolution: {
      href: "/casino/ezgevo-blackjack-silver-e",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverE.jpg",
        alt: "",
      },
    },
    BlackjackSilverFEvolution: {
      href: "/casino/ezgevo-blackjack-silver-f",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverF.jpg",
        alt: "",
      },
    },
    BlackjackSilverGEvolution: {
      href: "/casino/ezgevo-blackjack-silver-g",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackSilverG.jpg",
        alt: "",
      },
    },
    BlackjackVIP1Evolution: {
      href: "/casino/ezgevo-blackjack-vip-1",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP1.jpg", alt: "" },
    },
    BlackjackVIP2Evolution: {
      href: "/casino/ezgevo-blackjack-vip-2",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP2.jpg", alt: "" },
    },
    BlackjackVIP3Evolution: {
      href: "/casino/ezgevo-blackjack-vip-3",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP3.jpg", alt: "" },
    },
    BlackjackVIP4Evolution: {
      href: "/casino/ezgevo-blackjack-vip-4",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP4.jpg", alt: "" },
    },
    BlackjackVIP5Evolution: {
      href: "/casino/ezgevo-blackjack-vip-5",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP5.jpg", alt: "" },
    },
    BlackjackVIP6Evolution: {
      href: "/casino/ezgevo-blackjack-vip-6",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP6.jpg", alt: "" },
    },
    BlackjackVIP7Evolution: {
      href: "/casino/ezgevo-blackjack-vip-7",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP7.jpg", alt: "" },
    },

    BlackjackVIP8Evolution: {
      href: "/casino/ezgevo-blackjack-vip-8",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP8.jpg", alt: "" },
    },
    BlackjackVIP9Evolution: {
      href: "/casino/ezgevo-blackjack-vip-9",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIP9.jpg", alt: "" },
    },
    BlackjackVIP10Evolution: {
      href: "/casino/ezgevo-blackjack-vip-10",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackVIP10.jpg",
        alt: "",
      },
    },
    BlackjackVIPAEvolution: {
      href: "/casino/ezgevo-blackjack-vip-a",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPA.jpg", alt: "" },
    },
    BlackjackVIPAlphaEvolution: {
      href: "/casino/ezgevo-blackjack-vip-alpha",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackVIPAlpha.jpg",
        alt: "",
      },
    },
    BlackjackVIPBEvolution: {
      href: "/casino/ezgevo-blackjack-vip-b",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPB.jpg", alt: "" },
    },
    BlackjackVIPBetaEvolution: {
      href: "/casino/ezgevo-blackjack-vip-beta",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackVIPBeta.jpg",
        alt: "",
      },
    },
    BlackjackVIPCEvolution: {
      href: "/casino/ezgevo-blackjack-vip-c",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPC.jpg", alt: "" },
    },
    BlackjackVIPDEvolution: {
      href: "/casino/ezgevo-blackjack-vip-d",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPD.jpg", alt: "" },
    },
    BlackjackVIPEEvolution: {
      href: "/casino/ezgevo-blackjack-vip-e",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPE.jpg", alt: "" },
    },
    BlackjackVIPGEvolution: {
      href: "/casino/ezgevo-blackjack-vip-g",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPG.jpg", alt: "" },
    },
    BlackjackVIPHEvolution: {
      href: "/casino/ezgevo-blackjack-vip-h",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPH.jpg", alt: "" },
    },
    BlackjackVIPGammaEvolution: {
      href: "/casino/ezgevo-blackjack-vip-gamma",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/BlackjackVIPGamma.jpg",
        alt: "",
      },
    },
    BlackjackVIPIEvolution: {
      href: "/casino/ezgevo-blackjack-vip-i",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPI.jpg", alt: "" },
    },
    BlackjackVIPLEvolution: {
      href: "/casino/ezgevo-blackjack-vip-l",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPL.jpg", alt: "" },
    },
    BlackjackVIPMEvolution: {
      href: "/casino/ezgevo-blackjack-vip-m",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/evolution/BlackjackVIPM.jpg", alt: "" },
    },
    FirstPersonBlackjackEvolution: {
      href: "/casino/ezgevo-first-person-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/FirstPersonBlackjack.jpg",
        alt: "",
      },
    },
    FirstPersonLightningBlackjackEvolution: {
      href: "/casino/ezgevo-first-person-lightning-blackjack",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/blackjack/evolution/FirstPersonLightningBlackjack.jpg",
        alt: "",
      },
    },
  },

  thirtytwoCardtab: {
    thirtytwoCards: {
      href: "/casino/ezugi/thirtytwoCards",
      code: "228002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/card/32cards01.png", alt: "" },
    },
  },

  sevenLuckytab: {
    sevenLucky: {
      href: "/casino/ezugi/sevenLucky",
      code: "228001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/lucky7/Lucky011.png", alt: "" },
    },
  },

  sicbotab: {
    SicBo: {
      href: "/casino/ezg-sic-bo",
      code: "224000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/dragonsicbo/ezugi/Sicbo.jpg", alt: "" },
    },
    UltimateSicBo: {
      href: "/casino/ezg-ultimate-sic-bo",
      code: "224100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/popular/ezugi/UltimateSicBo.jpg", alt: "" },
    },
    SuperSicBo: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "1000110",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/topgames/evolution/SuperSicBo.jpg", alt: "" },
    },
    LightningDice: {
      href: "/casino/ezgevo-lightning-dice",
      code: "224100",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/gameshows/LightningDice.jpg", alt: "" },
    },
    FirstPersonMegaball: {
      href: "/casino/ezgevo-first-person-mega-ball",
      code: "224100",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/gameshows/FirstPersonMegaball.jpg", alt: "" },
    },
    Megaball: {
      href: "/casino/ezgevo-mega-ball",
      code: "224100",
      casino: "evolution",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/gameshows/Megaball.jpg", alt: "" },
    },
  },

  spribe: {
    href: "/casino/sprie",
    code: "",
    provider: "spribe",
    homeUrl: "",
    games: {
      mines: {
        href: "/casino/spribe/mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: "",
        cover: { src: "./images/spribe/02.jpg", alt: "" },
      },
      goal: {
        href: "/casino/spribe/goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: "",
        cover: { src: "./images/spribe/06.png", alt: "" },
      },
      dice: {
        href: "/casino/spribe/dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        cover: { src: "./images/spribe/07.jpg", alt: "" },
      },
      aviator: {
        href: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "",
        cover: { src: "./images/spribe/03.png", alt: "" },
      },
      pilnko: {
        href: "/casino/spribe/pilnko",
        code: "pilnko",
        casino: "spribe",
        provider: "pilnko",
        homeUrl: "",
        cover: { src: "./images/spribe/08.jpg", alt: "" },
      },
      miniroulette: {
        href: "/casino/spribe/miniroulette",
        code: "miniroulette",
        casino: "spribe",
        provider: "miniroulette",
        homeUrl: "",
        cover: { src: "./images/spribe/04.png", alt: "" },
      },
      hilo: {
        href: "/casino/spribe/hilo",
        code: "hilo",
        casino: "miniroulette",
        provider: "hilo",
        homeUrl: "",
        cover: { src: "./images/spribe/05.png", alt: "" },
      },
    },
  },

  Slots: {
    twinspin: {
      href: "/casino/ezugi/twinspin",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/twin-and-spin.jpg", alt: "" },
    },
    gonzoquest: {
      href: "/casino/ezugi/gonzoquest",
      code: "1100018",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/gonzo-treasure-hunt.jpg", alt: "" },
    },

    asgardianstones: {
      href: "/casino/ezugi/asgardianstones",
      code: "1100096",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/asgardianstones1.jpg", alt: "" },
    },
    secrets: {
      href: "/casino/ezugi/secrets",
      code: "1100106",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/secrets.jpg", alt: "" },
    },
    grandwheel: {
      href: "/casino/ezugi/grandwheel",
      code: "1100150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/Grand-wheel.jpg", alt: "" },
    },
    Strike777: {
      href: "/casino/ezugi/Strike777",
      code: "1100031",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Nights1000: {
      href: "/casino/ezugi/Nights1000",
      code: "1100003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CashUltimate: {
      href: "/casino/ezugi/CashUltimate",
      code: "1100070",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CashVolt: {
      href: "/casino/ezugi/CashVolt",
      code: "1100071",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DazzleMegaways: {
      href: "/casino/ezugi/DazzleMegaways",
      code: "1100083",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezugi/DivinieFortuneMegaways",
      code: "1100089",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Dynamiteriches: {
      href: "/casino/ezugi/Dynamiteriches",
      code: "1100073",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FortuneHouse: {
      href: "/casino/ezugi/FortuneHouse",
      code: "1100007",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FruitShopMegaways: {
      href: "/casino/ezugi/FruitShopMegaways",
      code: "1100094",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GoldenCryptex: {
      href: "/casino/ezugi/GoldenCryptex",
      code: "1100147",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GoldenTsar: {
      href: "/casino/ezugi/GoldenTsar",
      code: "1100149",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GorillaKingdom: {
      href: "/casino/ezugi/GorillaKingdom",
      code: "1100088",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MystryReels: {
      href: "/casino/ezugi/MystryReels",
      code: "1100061",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RageoftheSea: {
      href: "/casino/ezugi/RageoftheSea",
      code: "1100116",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ReelKingMegaways: {
      href: "/casino/ezugi/ReelKingMegaways",
      code: "1100052",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TurnFortune: {
      href: "/casino/ezugi/TurnFortune",
      code: "1100041",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TwinSpinMegaways: {
      href: "/casino/ezugi/TwinSpinMegaways",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WillysChills: {
      href: "/casino/ezugi/WillysChills",
      code: "1100128",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    VikingsSlots: {
      href: "/casino/ezugi/VikingsSlots",
      code: "1100124",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },

    ChineseTreasures: {
      href: "/casino/ezugi/ChineseTreasures",
      code: "1100006",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DragonLuck: {
      href: "/casino/ezugi/DragonLuck",
      code: "1100001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DragonFire: {
      href: "/casino/ezugi/DragonFire",
      code: "1100008",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DragonLuckDeluxe: {
      href: "/casino/ezugi/DragonLuckDeluxe",
      code: "1100011",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DragonLuckReel: {
      href: "/casino/ezugi/DragonLuckReel",
      code: "1100002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    EpicJourney: {
      href: "/casino/ezugi/EpicJourney",
      code: "1100012",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GodWealth: {
      href: "/casino/ezugi/GodWealth",
      code: "1100005",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LuckyFortune: {
      href: "/casino/ezugi/LuckyFortune",
      code: "1100010",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MagicGate: {
      href: "/casino/ezugi/MagicGate",
      code: "1100009",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GoldenTemple: {
      href: "/casino/ezugi/GoldenTemple",
      code: "1100013",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PhoenixPower: {
      href: "/casino/ezugi/PhoenixPower",
      code: "1100014",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PiratesPlenty: {
      href: "/casino/ezugi/PiratesPlenty",
      code: "1100015",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GoldenOffer: {
      href: "/casino/ezugi/GoldenOffer",
      code: "1100016",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RAsLegend: {
      href: "/casino/ezugi/RAsLegend",
      code: "1100017",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GonzoMegawaya: {
      href: "/casino/ezugi/GonzoMegawaya",
      code: "1100018                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RainbowJAcket: {
      href: "/casino/ezugi/RainbowJAcket",
      code: "1100019                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MegaPyramid: {
      href: "/casino/ezugi/MegaPyramid",
      code: "1100020                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Ozzy_Osbourne: {
      href: "/casino/ezugi/Ozzy_Osbourne",
      code: "1100024                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Jimi_Hendrix: {
      href: "/casino/ezugi/Jimi_Hendrix",
      code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Jimi_Hendrix: {
      href: "/casino/ezugi/Jimi_Hendrix",
      code: "1100026                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Jumanji: {
      href: "/casino/ezugi/Jumanji",
      code: "1100027                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MotorheadVideoSlot: {
      href: "/casino/ezugi/MotorheadVideoSlot",
      code: "1100028                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Starburst: {
      href: "/casino/ezugi/Starburst",
      code: "1100029                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WarofGod: {
      href: "/casino/ezugi/WarofGod",
      code: "1100030                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Christmas: {
      href: "/casino/ezugi/Christmas",
      code: "1100032                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ClusterPays: {
      href: "/casino/ezugi/ClusterPays",
      code: "1100033                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    AncientsBlessing: {
      href: "/casino/ezugi/AncientsBlessing",
      code: "1100034                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    AurumCodex: {
      href: "/casino/ezugi/AurumCodex",
      code: "1100035                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GunsNRoses: {
      href: "/casino/ezugi/GunsNRoses",
      code: "1100036                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    BorisandBoo: {
      href: "/casino/ezugi/BorisandBoo",
      code: "1100037                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildWest: {
      href: "/casino/ezugi/WildWest",
      code: "1100038                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SteamTower: {
      href: "/casino/ezugi/SteamTower",
      code: "1100043                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ZeusLightning: {
      href: "/casino/ezugi/ZeusLightning",
      code: "1100044                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WingsofRa: {
      href: "/casino/ezugi/WingsofRa",
      code: "1100045                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Trillionaire: {
      href: "/casino/ezugi/Trillionaire",
      code: "1100047                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TreasureMine: {
      href: "/casino/ezugi/TreasureMine",
      code: "1100048                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ThorVengeance: {
      href: "/casino/ezugi/ThorVengeance",
      code: "1100049                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RegalStreak: {
      href: "/casino/ezugi/RegalStreak",
      code: "1100050                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RegalBeasts: {
      href: "/casino/ezugi/RegalBeasts",
      code: "1100051                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ReelKeeper: {
      href: "/casino/ezugi/ReelKeeper",
      code: "1100053                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RainbowJackpotsPowerLines: {
      href: "/casino/ezugi/RainbowJackpotsPowerLines",
      code: "1100055                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PiggyRichesMegaways: {
      href: "/casino/ezugi/PiggyRichesMegaways",
      code: "1100059                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JingleBells: {
      href: "/casino/ezugi/JingleBells",
      code: "1100065                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JackinaPot: {
      href: "/casino/ezugi/JackinaPot",
      code: "1100066                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FiveStar: {
      href: "/casino/ezugi/FiveStar",
      code: "1100068                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    BountyRaid: {
      href: "/casino/ezugi/BountyRaid",
      code: "1100069                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MysteryReels2: {
      href: "/casino/ezugi/MysteryReels2",
      code: "1100061                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DiamondBlitz: {
      href: "/casino/ezugi/DiamondBlitz",
      code: "1100072                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DragonFireMegaways: {
      href: "/casino/ezugi/DragonFireMegaways",
      code: "1100074                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Rome: {
      href: "/casino/ezugi/Rome",
      code: "1100075                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ReelRush: {
      href: "/casino/ezugi/ReelRush",
      code: "1100076                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    BloodSuckers: {
      href: "/casino/ezugi/BloodSuckers",
      code: "1100077                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Pyramid: {
      href: "/casino/ezugi/Pyramid",
      code: "1100078                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ButterflyStaxx: {
      href: "/casino/ezugi/ButterflyStaxx",
      code: "1100079                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PiggyRiches: {
      href: "/casino/ezugi/PiggyRiches",
      code: "1100080                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DarkKing: {
      href: "/casino/ezugi/DarkKing",
      code: "1100081                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JingleSpin: {
      href: "/casino/ezugi/JingleSpin",
      code: "1100082                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Dazzle: {
      href: "/casino/ezugi/Dazzle",
      code: "1100083                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JackHammer: {
      href: "/casino/ezugi/JackHammer",
      code: "1100084                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DeadorAlive: {
      href: "/casino/ezugi/DeadorAlive",
      code: "1100085                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JackandtheBeanstalk: {
      href: "/casino/ezugi/JackandtheBeanstalk",
      code: "1100086                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DeadorAlive2: {
      href: "/casino/ezugi/DeadorAlive2",
      code: "1100087                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DivineFortuneMegaways: {
      href: "/casino/ezugi/DivineFortuneMegaways",
      code: "1100089                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GordonRamsayHellsKitchen: {
      href: "/casino/ezugi/GordonRamsayHellsKitchen",
      code: "1100090                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Elements: {
      href: "/casino/ezugi/Elements",
      code: "1100091                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GonzosQuest: {
      href: "/casino/ezugi/GonzosQuest",
      code: "1100092                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FinnandtheSwirlySpin: {
      href: "/casino/ezugi/FinnandtheSwirlySpin",
      code: "1100093                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FruitShop: {
      href: "/casino/ezugi/FruitShop",
      code: "1100095                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    BloodSuckers2: {
      href: "/casino/ezugi/BloodSuckers2",
      code: "1100097                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ButterflyStaxx2: {
      href: "/casino/ezugi/ButterflyStaxx2",
      code: "1100098                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DazzleMeMegaways: {
      href: "/casino/ezugi/DazzleMeMegaways",
      code: "1100099                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DeadorAlive2FeatureBuy: {
      href: "/casino/ezugi/DeadorAlive2FeatureBuy",
      code: "1100100                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DoubleStacks: {
      href: "/casino/ezugi/DoubleStacks",
      code: "1100101                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FairytaleLegends: {
      href: "/casino/ezugi/FairytaleLegends",
      code: "1100102                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Flowers: {
      href: "/casino/ezugi/Flowers",
      code: "1100103                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FruitShopChristmasEdition: {
      href: "/casino/ezugi/FruitShopChristmasEdition",
      code: "1100104                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Hotline: {
      href: "/casino/ezugi/Hotline",
      code: "1100107                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Hotline2: {
      href: "/casino/ezugi/Hotline2",
      code: "1100108                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TheInvisibleMan: {
      href: "/casino/ezugi/TheInvisibleMan",
      code: "1100109                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    IrishPotLuck: {
      href: "/casino/ezugi/IrishPotLuck",
      code: "1100110                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JackHammer2: {
      href: "/casino/ezugi/JackHammer2",
      code: "1100111                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FruitSpin: {
      href: "/casino/ezugi/FruitSpin",
      code: "1100112                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JungleSpirit: {
      href: "/casino/ezugi/JungleSpirit",
      code: "1100113                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    KoiPrincess: {
      href: "/casino/ezugi/KoiPrincess",
      code: "1100114                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DriveMultiplierMayhem: {
      href: "/casino/ezugi/DriveMultiplierMayhem",
      code: "1100115                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RageoftheSeas: {
      href: "/casino/ezugi/RageoftheSeas",
      code: "1100116                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RichesofMidgard: {
      href: "/casino/ezugi/RichesofMidgard",
      code: "1100117                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ScruffyDuck: {
      href: "/casino/ezugi/ScruffyDuck",
      code: "1100118                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SecretoftheStones: {
      href: "/casino/ezugi/SecretoftheStones",
      code: "1100119                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SecretsofChristmas: {
      href: "/casino/ezugi/SecretsofChristmas",
      code: "1100120                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SerengetiKings: {
      href: "/casino/ezugi/SerengetiKings",
      code: "1100121                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SpaceWars: {
      href: "/casino/ezugi/SpaceWars",
      code: "1100122                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Victorious: {
      href: "/casino/ezugi/Victorious",
      code: "1100123                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Warlords: {
      href: "/casino/ezugi/Warlords",
      code: "1100125                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildWater: {
      href: "/casino/ezugi/WildWater",
      code: "1100126                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildWorlds: {
      href: "/casino/ezugi/WildWorlds",
      code: "1100127                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Squad4: {
      href: "/casino/ezugi/Squad4",
      code: "1100129                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Families5: {
      href: "/casino/ezugi/Families5",
      code: "1100130                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    AgentRoyale: {
      href: "/casino/ezugi/AgentRoyale",
      code: "1100131                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ArcadeBomb: {
      href: "/casino/ezugi/ArcadeBomb",
      code: "1100132                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Atlantis: {
      href: "/casino/ezugi/Atlantis",
      code: "1100133                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    AztecSpins: {
      href: "/casino/ezugi/AztecSpins",
      code: "1100134                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CinderellaBall: {
      href: "/casino/ezugi/CinderellaBall",
      code: "1100135                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CirquedelaFortune: {
      href: "/casino/ezugi/CirquedelaFortune",
      code: "1100136                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ClashoftheBeasts: {
      href: "/casino/ezugi/ClashoftheBeasts",
      code: "1100137                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CrazyGenie: {
      href: "/casino/ezugi/CrazyGenie",
      code: "1100138                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    CrystalMirror: {
      href: "/casino/ezugi/CrystalMirror",
      code: "1100139                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DaVinciMystery: {
      href: "/casino/ezugi/DaVinciMystery",
      code: "1100140                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DevilNumber: {
      href: "/casino/ezugi/DevilNumber",
      code: "1100141                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    DiceDice: {
      href: "/casino/ezugi/DiceDice",
      code: "1100142                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    FiveStarsPowerReels: {
      href: "/casino/ezugi/FiveStarsPowerReels",
      code: "1100144                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GemsGoneWild: {
      href: "/casino/ezugi/GemsGoneWild",
      code: "1100145                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GemsGoneWildPowerReels: {
      href: "/casino/ezugi/GemsGoneWildPowerReels",
      code: "1100146                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    GoldenLeprechaunMegaways: {
      href: "/casino/ezugi/GoldenLeprechaunMegaways",
      code: "1100148                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    HoardofPoseidon: {
      href: "/casino/ezugi/HoardofPoseidon",
      code: "1100151                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JewelScarabs: {
      href: "/casino/ezugi/JewelScarabs",
      code: "1100152                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    JingleBellsPowerReels: {
      href: "/casino/ezugi/JingleBellsPowerReels",
      code: "1100153                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LegendofAthena: {
      href: "/casino/ezugi/LegendofAthena",
      code: "1100154                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LuckyHalloween: {
      href: "/casino/ezugi/LuckyHalloween",
      code: "1100155                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LuckyLittleDevil: {
      href: "/casino/ezugi/LuckyLittleDevil",
      code: "1100156                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LuckyValentine: {
      href: "/casino/ezugi/LuckyValentine",
      code: "1100157                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    LuckyWizard: {
      href: "/casino/ezugi/LuckyWizard",
      code: "1100158                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    Masquerade: {
      href: "/casino/ezugi/Masquerade",
      code: "1100159                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MayanGods: {
      href: "/casino/ezugi/MayanGods",
      code: "1100160                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MegaDragon: {
      href: "/casino/ezugi/MegaDragon",
      code: "1100161                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MegaJade: {
      href: "/casino/ezugi/MegaJade",
      code: "1100162                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MegaRise: {
      href: "/casino/ezugi/MegaRise",
      code: "1100163                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MultiplierRiches: {
      href: "/casino/ezugi/MultiplierRiches",
      code: "1100164                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    MysteryReelsMegaways: {
      href: "/casino/ezugi/MysteryReelsMegaways",
      code: "1100165                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    NinjaWays: {
      href: "/casino/ezugi/NinjaWays",
      code: "1100166                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PathofDestiny: {
      href: "/casino/ezugi/PathofDestiny",
      code: "1100167                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    PersianFortune: {
      href: "/casino/ezugi/PersianFortune",
      code: "1100168                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ReelHeist: {
      href: "/casino/ezugi/ReelHeist",
      code: "1100169                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    RobinHoodWildForest: {
      href: "/casino/ezugi/RobinHoodWildForest",
      code: "1100170                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SnowWild: {
      href: "/casino/ezugi/SnowWild",
      code: "1100171                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    SylvanSpirits: {
      href: "/casino/ezugi/SylvanSpirits",
      code: "1100172                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TheGreatestTrainRobbery: {
      href: "/casino/ezugi/TheGreatestTrainRobbery",
      code: "1100173                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TheWildHatter: {
      href: "/casino/ezugi/TheWildHatter",
      code: "1100174                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    ThorLightning: {
      href: "/casino/ezugi/ThorLightning",
      code: "1100175                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TikiFruits: {
      href: "/casino/ezugi/TikiFruits",
      code: "1100176                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    TotemLightning: {
      href: "/casino/ezugi/TotemLightning",
      code: "1100177                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    VaultCracker: {
      href: "/casino/ezugi/VaultCracker",
      code: "1100178                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    VaultofAnubis: {
      href: "/casino/ezugi/VaultofAnubis",
      code: "1100179                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WellofWishes: {
      href: "/casino/ezugi/WellofWishes",
      code: "1100180                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildCatsMultiline: {
      href: "/casino/ezugi/WildCatsMultiline",
      code: "1100181                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildOClock: {
      href: "/casino/ezugi/WildOClock",
      code: "1100182                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WildChest: {
      href: "/casino/ezugi/WildChest",
      code: "1100183                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    WinEscalator: {
      href: "/casino/ezugi/WinEscalator",
      code: "1100184                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
    YucatanMystery: {
      href: "/casino/ezugi/YucatanMystery",
      code: "1100185                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/777_Strike.png", alt: "" },
    },
  },

  popularGames: {
    VivoTeenPatti: {
      redirectUrl: "/casino/vivo-teen-patti",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/VivoTeenPatti1.jpg",
      name: "vivo teen patti",
    },
    VivoAndarBahar: {
      redirectUrl: "/casino/vivo-andar-bahar",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/VivoAndarBahar1.jpg",
      name: "vivo andar bahar",
    },
    OracleBlazeRoulette: {
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Oracleblazetoulette.jpg",
      name: "Oracle Blaze Roulette",
    },
    OracleBlazze360Roulette: {
      redirectUrl: "/casino/vivo-oracle-360-roulette",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/oracleblazzeroulette.jpg",
      name: "dragon tiger",
    },
    KingRace: {
      redirectUrl: "/casino/sn-rng-worli-matka",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/worlimatka.jpg",
      name: "King Race",
    },
    Lucky7Supernowa: {
      redirectUrl: "/casino/sn-lucky-7",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/lucky7.jpg",
      name: "Lucky7",
    },
    Goldblackjack: {
      redirectUrl: "/casino/ezg-gold-blackjack-1",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/goldblackjack.jpg",
      name: "Gold Blackjack",
    },
    GalaxyBaccarat3: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-3",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/galaxybaccarat3.jpg",
      name: "Galaxy Baccarat 3",
    },
    GalaxyBaccarat1: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-1",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/galaxybaccarat1.jpg",
      name: "Galaxy Baccarat 1",
    },
    CasinoholdemVivo: {
      redirectUrl: "/casino/sn-rng-casino-queen-2020",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/casinoqueen.jpg",
      name: "Casino Hold'em Vivo",
    },
    Sicbo: {
      redirectUrl: "/casino/ezg-sic-bo",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Sicbo.jpg",
      name: "sic-bo",
    },
    Spanishroulette: {
      redirectUrl: "/casino/ezg-spanish-roulette",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Spanishroulette.jpg",
      name: "spanish roulette",
    },
    Teenpatticard: {
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Teenpatticard.jpg",
      name: "teen patti 3 card",
    },

    AkbarRomeoWalter: {
      redirectUrl: "/casino/sn-akbar-romeo-walter",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/akbarromeowalter.jpg",
      name: "Akbar Romeo Walter",
    },
    Ultimatesicbo: {
      redirectUrl: "/casino/ezg-ultimate-sic-bo",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Ultimatesicbo.jpg",
      name: "ultimate sic bo",
    },
    autoRoulette: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/autoroulette.jpg",
      name: "auto roulette",
    },
    casinomarinaRoulette: {
      redirectUrl: "/casino/ezg-casino-marina-roulette-1",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/casinomarinaroulette.jpg",
      name: "casino marina roulette-1",
    },
    Aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/AVIATOR.jpg",
      name: "aviator",
    },
    UltimateRoulette: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/UltimateRoulette.jpg",
      name: "ultimate roulette",
    },
    AndarBaharEzugi: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/popular/game/Andarbahar.jpg",
      name: "andar bahar",
    },
  },

  trendingGames: {
    Matka: {
      redirectUrl: "/casino/ezg-matka",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: "/home",
      imgUrl: "./images/popular/game/Matka.webp",
      alt: "matka",
      name: "Matka",
    },
    Ludo: {
      redirectUrl: "/casino/km-ludo",
      code: "",
      casino: "kingmaker",
      provider: "Kingmaker",
      homeUrl: "/home",
      imgUrl: "./images/popular/game/Ludo.webp",
      alt: "ludo",
      name: "Ludo",
    },
    LightningStorm: {
      redirectUrl: "/casino/ezgevo-gonzos-lightning-storm",
      code: "",
      casino: "ezugi",
      provider: "Evolution",
      homeUrl: "/home",
      imgUrl: "./images/popular/game/Lightning-Storm.webp",
      alt: "lightning storm",
      name: "Lightning Storm",
    },
    Aero: {
      redirectUrl: "/casino/qtechturbogames-aero",
      code: "",
      casino: "qtech",
      provider: "Qtech",
      homeUrl: "/home",
      imgUrl: "./images/popular/game/Aero.webp",
      alt: "aero",
      name: "Aero",
    },
  },

  lobby: {
    Ezugi: {
      href: "/casino/ezugi",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Ezugi.webp",
      alt: "Ezugi",
      name: "Ezugi",
    },
    Evolution: {
      href: "/casino/evolution",
      code: "/home",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: "",
      imgUrl: "./images/providers/new/Evolution.webp",
      alt: "Evolution",
      name: "Evolution",
    },
    Vivo: {
      href: "/casino/vivo",
      code: "",
      casino: "vivo",
      provider: "Vivo",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Vivo.webp",
      alt: "Vivo",
      name: "Vivo",
    },
    Supernowa: {
      href: "/casino/supernowa",
      code: "",
      casino: "supernowa",
      provider: "Worldcasino",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Supernowa.webp",
      alt: "Supernowa",
      name: "Supernowa",
    },
    Qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "qtech",
      provider: "Qtech",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Qtech.webp",
      alt: "Qtech",
      name: "Qtech",
    },
    Worldcasino: {
      href: "/casino/worldcasino",
      code: "",
      casino: "worldcasino",
      provider: "Worldcasino",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Worldcasino.webp",
      alt: "Worldcasino",
      name: "Worldcasino",
    },
    XPG: {
      href: "/casino/xpg",
      code: "",
      casino: "xpg",
      provider: "Worldcasino",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/XPG.webp",
      alt: "XPG",
      name: "XPG",
    },
    Spribe: {
      href: "/spribe",
      code: "",
      casino: "spribe",
      provider: "Spribe",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Spribe.webp",
      alt: "Spribe",
      name: "Spribe",
    },
    Kingmaker: {
      href: "/kingmaker",
      code: "",
      casino: "kingmaker",
      provider: "Kingmaker",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Kingmaker.webp",
      alt: "Kingmaker",
      name: "Kingmaker",
    },
    Slots: {
      href: "/slots-games",
      code: "",
      casino: "slots",
      provider: "Slots",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/Slots.webp",
      alt: "Slots",
      name: "Slots",
    },
    AeSexy: {
      href: "/casino/aesexy",
      code: "",
      casino: "aesexy",
      provider: "AeSexy",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/AeSexy.webp",
      alt: "AeSexy",
      name: "AeSexy",
    },
    PowerGames: {
      href: "/casino/powergames",
      code: "",
      casino: "powergames",
      provider: "Worldcasino",
      homeUrl: "/home",
      imgUrl: "./images/providers/new/PowerGames.webp",
      alt: "powergames",
      name: "powergames",
    },
  },
};
